import React from 'react';
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Curriculum from './components/Curriculum';
import Admission from './components/Admission';
import Internship from './components/Internship';
import Gallery from './components/Gallery';
import Careers from './components/Careers';
import Footer from './components/Footer';

const App = () => (
  <Box>
    <Navbar />
    <Hero />
    <About />
    <Curriculum />
    <Admission />
    <Internship />
    <Gallery />
    <Careers />
    <Footer />
  </Box>
);

export default App;
